import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { ChatChannelList, ChatRoom } from "@/components/Chat";

/** Pantalla de Chats. Funciona en desktop y mobile (responsive).
 * Fix W (2026-09-11): abrir un canal empuja ?channel=<id> a la URL, así el
 * botón "atrás" del navegador vuelve al listado de chats (antes volvía a la
 * pantalla anterior del menú porque abrir un chat no generaba historial). */
export default function ChatsPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeChannelId = searchParams.get("channel");
  const [channel, setChannel] = useState(null);
  const [allChannels, setAllChannels] = useState({ groups: [], dms: [] });

  useEffect(() => {
    if (!activeChannelId) { setChannel(null); return; }
    const found = [...allChannels.groups, ...allChannels.dms].find((c) => c.channel_id === activeChannelId);
    if (found) setChannel(found);
  }, [activeChannelId, allChannels]);

  const selectChannel = (ch) => { setChannel(ch); setSearchParams({ channel: ch.channel_id }); };
  const backToList = () => setSearchParams({});

  return (
    <div style={{ height: "calc(100vh - 60px)", display: "flex" }} data-testid="chats-page">
      <aside style={{
        width: 300, background: "#fff", borderRight: "1px solid var(--invict-bone-3)",
        overflowY: "auto", display: channel ? "none" : "block",
      }} className="chat-aside">
        <div style={{ padding: "16px 14px 0" }}>
          <h2 style={{ fontSize: 18, fontWeight: 900, color: "#0A0A0A", margin: 0 }}>Chats</h2>
          <div style={{ fontSize: 11, color: "var(--invict-text-muted)", marginTop: 2 }}>Comunicación por objetivo</div>
        </div>
        <ChatChannelList onSelect={selectChannel} activeId={channel?.channel_id} onData={setAllChannels} />
      </aside>
      <main style={{ flex: 1, display: "flex", flexDirection: "column" }}>
        {channel && (
          <button onClick={backToList} className="chat-back" style={{
            display: "flex", alignItems: "center", gap: 6, background: "none",
            borderWidth: "0 0 1px 0", borderStyle: "solid", borderColor: "var(--invict-bone-3)", color: "var(--invict-text-muted)",
            padding: "12px 16px", fontSize: 12, fontWeight: 700, textTransform: "uppercase",
            letterSpacing: "0.05em", cursor: "pointer", textAlign: "left", flexShrink: 0,
          }} data-testid="chat-back"><ArrowLeft size={14} /> Volver a chats</button>
        )}
        <div style={{ flex: 1, minHeight: 0 }}><ChatRoom channel={channel} /></div>
      </main>
      <style>{`
        @media (max-width: 768px) {
          .chat-aside { width: 100% !important; }
        }
      `}</style>
    </div>
  );
}

